/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most green teas are steeped for 1 to 3 minutes in water around 160-180°F (70-80°C); two minutes is a common middle ground. Steeping longer tends to pull out more tannins and taste bitter, so timing it matters more for green tea than for black tea.`)
};

const es_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mayoría de los tés verdes se dejan en infusión de 1 a 3 minutos en agua a unos 70-80°C (160-180°F); dos minutos es un término medio común. Una infusión más larga tiende a extraer más taninos y sabe amargo, así que cronometrarlo importa más para el té verde que para el té negro.`)
};

const de_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die meisten grünen Tees ziehen 1 bis 3 Minuten in Wasser bei etwa 70–80 °C; zwei Minuten sind ein gängiger Mittelwert. Längeres Ziehen zieht mehr Gerbstoffe heraus und schmeckt bitter, weshalb das Timing bei grünem Tee wichtiger ist als bei schwarzem.`)
};

const nl_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De meeste groene thee wordt 1 tot 3 minuten getrokken in water van ongeveer 70-80°C; twee minuten is een gangbaar gemiddelde. Langer trekken haalt meer tannines eruit en smaakt bitterder, dus timing is belangrijker bij groene thee dan bij zwarte thee.`)
};

const fr_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La plupart des thés verts infusent de 1 à 3 minutes dans une eau à environ 70-80 °C ; deux minutes est un juste milieu courant. Une infusion plus longue tend à libérer davantage de tanins et à donner un goût amer, c’est pourquoi le chronométrage compte plus pour le thé vert que pour le thé noir.`)
};

const it_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La maggior parte dei tè verdi viene lasciata in infusione per 1-3 minuti in acqua a circa 70-80°C; due minuti sono una via di mezzo comune. Un'infusione più lunga tende a estrarre più tannini e a risultare amara, quindi cronometrarla è più importante per il tè verde che per il tè nero.`)
};

const pt_br2_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria dos chás verdes é preparada em infusão de 1 a 3 minutos em água a cerca de 70-80°C; dois minutos é um meio-termo comum. Deixar por mais tempo tende a extrair mais taninos e deixar o sabor amargo, então cronometrar importa mais para o chá verde do que para o chá preto.`)
};

const pt_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria dos chás verdes fica em infusão entre 1 e 3 minutos, em água a cerca de 70-80°C; dois minutos é um valor intermédio comum. Uma infusão mais longa tende a extrair mais taninos e a ficar amarga, por isso a cronometragem importa mais no chá verde do que no chá preto.`)
};

const ja_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多くの緑茶は70〜80°C程度のお湯で1〜3分浸出させ、2分が一般的な目安です。長く浸出させるとタンニンが多く出て苦味が強くなるため、紅茶よりも緑茶の方が時間管理が重要になります。`)
};

const zh_timer_u2m_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大多数绿茶在约160-180°F（70-80°C）的水温下冲泡1到3分钟；两分钟是常见的折中时长。冲泡时间过长往往会析出更多单宁，导致口感发苦，因此对绿茶而言，计时比红茶更重要。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u2m_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u2m_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u2m_faq4_a", locale)
	if (locale === "en") return en_timer_u2m_faq4_a(inputs)
	if (locale === "es") return es_timer_u2m_faq4_a(inputs)
	if (locale === "de") return de_timer_u2m_faq4_a(inputs)
	if (locale === "nl") return nl_timer_u2m_faq4_a(inputs)
	if (locale === "fr") return fr_timer_u2m_faq4_a(inputs)
	if (locale === "it") return it_timer_u2m_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u2m_faq4_a(inputs)
	if (locale === "pt") return pt_timer_u2m_faq4_a(inputs)
	if (locale === "ja") return ja_timer_u2m_faq4_a(inputs)
	return zh_timer_u2m_faq4_a(inputs)
};